import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../config/endpoints";
import axiosConfig from "../../../utils/axiosConfig";
import storeInit from "../../store";
import { api_Secret, api_key } from "../../../config/appSettings";


// const token = storeInit.store.getState()?.user?.user?.accessTokens?.token?.token
// const config = {
//   headers: {
//     "Content-Type": "application/json",
//     Authorization: `Bearer ${token}`,
//     source: "web",
//     api_key,
//     api_Secret,
//   },
// };

const initialState = {
  regions: [],
  states: [],
  lgas: [],
  loadingState: false,
  loadingLga: false,
  error: "",
};

// New - starts
export const getAllStates = createAsyncThunk("states/fetch", async () => {
  return axiosConfig(endpoints.getStates, "GET", null);
});

export const getStateLgas = createAsyncThunk("lgas/fetch", async (stateId) => {
  const endpointToCall = `${endpoints.getLgas}?$filter=state_id eq ${stateId}`;
  return axiosConfig(endpointToCall);
});
// New - ends

const regionSlice = createSlice({
  name: "regions",
  initialState,
  reducers: {
    setLgasToEmptyArr: (state, action) => {
      state.lgas = [];
    },
  },
  extraReducers: (builder) => {
    // States - starts
    builder.addCase(getAllStates.pending, (state) => {
      state.loadingState = true;
    });
    builder.addCase(getAllStates.fulfilled, (state, action) => {
      state.loadingState = false;
      state.states = action?.payload?.data?.value;
      state.error = "";
    });
    builder.addCase(getAllStates.rejected, (state, action) => {
      state.loadingState = false;
      state.states = {};
      state.error = "Error, Failed to load states...";
    });

    // Lgas - starts
    builder.addCase(getStateLgas.pending, (state) => {
      state.loadingLga = true;
    });
    builder.addCase(getStateLgas.fulfilled, (state, action) => {
      state.loadingLga = false;
      state.lgas = action.payload?.data?.value;
      state.error = "";
    });
    builder.addCase(getStateLgas.rejected, (state, action) => {
      state.loadingLga = false;
      state.lgas = {};
      state.error = "Error, Failed to load lgas...";
    });
  },
});

export default regionSlice.reducer;
export const { setLgasToEmptyArr } = regionSlice.actions;
